import {Injectable} from '@angular/core';
import i18next from 'i18next';
import {isFfpError, isVirusInfectedError} from "../model/error-model";


export interface FfpMessage {
    title: string;
    detail: string;
}


@Injectable({providedIn: 'root'})
export class ErrorMessageService {

    getErrorKey(error: any): string {
        if (isFfpError(error)) {
            return this.getFfpErrorKey(error.fehler_id).detail;
        }
        else if (isVirusInfectedError(error)) {
            return 'error.upload.virus-infected';
        }
        else if (i18next.exists(error?.message)) {
            return error.message;
        } else {
            return 'error.upload.generic';
        }
    }

    getFfpErrorKey(code: string): FfpMessage {

        const key = code.substring(4);

        if (key) {

            const base = `error.upload.ffp.${key}`;
            const titleKey = `${base}.title`;
            const detailKey = `${base}.detail`;


            if (i18next.exists(titleKey) && i18next.exists(detailKey)) {
                return {
                    title: titleKey,
                    detail: detailKey
                };
            }
        }
        // Fallback, wenn der Code nicht in der JSON-Resource existiert
        return {
            title: 'error.upload.ffp.unknown.title',
            detail: 'error.upload.ffp.unknown.detail'
        };
    }


}